import mapActions from './mapActions';

export default mapActions('store_content', {
    fetchAll_url: data => `/api/storage/store_content/${data.id}`
});
